export default __webpack_public_path__ + "static/media/res-tradex.6260bd15.jpg";